/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PerformSetCompanyNotesMutationResponse,
  PerformSetCompanyNotesPathParams,
  PerformSetCompanyNotes404,
} from '../types/PerformSetCompanyNotes'

function getPerformSetCompanyNotesUrl({
  import_number,
}: {
  import_number: PerformSetCompanyNotesPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/set-company-notes/` as const,
  }
  return res
}

/**
 * @summary Dispatch the set-company-notes step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/set-company-notes/}
 */
export async function performSetCompanyNotes(
  {
    import_number,
  }: { import_number: PerformSetCompanyNotesPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PerformSetCompanyNotesMutationResponse,
    ResponseErrorConfig<PerformSetCompanyNotes404>,
    unknown
  >({
    method: 'POST',
    url: getPerformSetCompanyNotesUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
